import { formatTimeAgo } from "../formatTimeAgo";
import { EventsTimelineData, RecentActivityData, ResourceTypeData, TopComputerData, TopResourceData, TopUserData } from "../interfaces/CommonInterfaces";

const colors = ['#3b82f6', '#ef4444', '#22c55e', '#f59e0b', '#8b5cf6'];

export const mapResourceType = (response: { name: string; count: number }[]): ResourceTypeData[] => {
  if (!response || response.length === 0) return [];

  const sorted = [...response].sort((a, b) => b.count - a.count);

  return sorted.map((item, index) => ({
    name: item.name,
    value: item.count,
    color: colors[index % colors.length],
  }));
};

export const mapEventTimeLine = (
  eventTimeLine: { date: string; count: number }[]
): EventsTimelineData[] => {
  if (!eventTimeLine || eventTimeLine.length === 0) return [];

  return eventTimeLine.map((item) => ({
    date: item.date,
    events: item.count,
  }));
};


export const mapTopUsers = (users: { name: string; count: number }[]): TopUserData[] => {
  if (!users || users.length === 0) return [];

  const totalCount = users.reduce((sum, u) => sum + u.count, 0);

  return users.map((u, index) => ({
    id: (index + 1).toString(),
    user: u.name,
    count: u.count,
    percent: Math.round((u.count / totalCount) * 100),
  }));
};

export const mapTopResources = (resources: { name: string; count: number }[]): TopResourceData[] => {
  if (!resources || resources.length === 0) return [];

  const maxCount = Math.max(...resources.map(r => r.count));

  return resources.map((r, index) => ({
    id: (index + 1).toString(),
    resource: r.name,
    count: r.count,
    percent: Math.round((r.count / maxCount) * 100),
  }));
};
export const mapTopComputer = (name: { name: string; count: number }[]): TopComputerData[] => {
  if (!name || name.length === 0) return [];

  const totalCount = name.reduce((sum, u) => sum + u.count, 0);

  return name.map((u, index) => ({
    id: (index + 1).toString(),
    name: u.name,
    count: u.count,
    percent: Math.round((u.count / totalCount) * 100),
  }));
};



export const mapRecentActivity = (data: any[]): RecentActivityData[] => {
  if (!data || !Array.isArray(data)) return [];

  return data.map((item, index) => ({
    id: `${item.computerId || index}-${index}`,
    event: item.resourceType || "Unknown",
    from: item.tenantName || "Unknown",
    details: item.message || "",
    time: item.timestamp ? formatTimeAgo(item.timestamp) : item._time ? formatTimeAgo(item._time) : "",
    description: item.message || "",
    computer: item.computerName || "",
    user: item.computerUserEmail || "",
    path: item.resourceName || "",
  }));
};